import { configureStore } from '@reduxjs/toolkit';
import { authReducer } from './reducers/authReducer';
import { orderReducer } from './reducers/orderReducer';
import { loadReducer } from './reducers/loadReducer';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    order: orderReducer,
    load: loadReducer
  }
}); 